/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductSearchFacetValue } from './ProductSearchFacetValue';
// @ts-ignore
import {
// @ts-ignore
    ProductSearchFacetValueFromJSON,
// @ts-ignore
    ProductSearchFacetValueFromJSONTyped,
// @ts-ignore
    ProductSearchFacetValueToJSON,
} from './ProductSearchFacetValue';

/**
 * 
 * @export
 * @interface ProductSearchFacet
 */
export interface ProductSearchFacet {
    /**
     * 
     * @type {string}
     * @memberof ProductSearchFacet
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchFacet
     */
    name: string;
    /**
     * 
     * @type {Array<ProductSearchFacetValue>}
     * @memberof ProductSearchFacet
     */
    values: Array<ProductSearchFacetValue>;
}

/**
 * Check if a given object implements the ProductSearchFacet interface.
 */
// @ts-ignore
export function instanceOfProductSearchFacet(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

// @ts-ignore
export function ProductSearchFacetFromJSON(json: any): ProductSearchFacet {
    return ProductSearchFacetFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductSearchFacetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSearchFacet {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'values': ((json['values'] as Array<any>).map(ProductSearchFacetValueFromJSON)),
    };
}

// @ts-ignore
export function ProductSearchFacetToJSON(value?: ProductSearchFacet | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'values': ((value.values as Array<any>).map(ProductSearchFacetValueToJSON)),
    };
}

